import { ITeamsDriversCards } from "@sky-it-livedata/livedata-sports-design-system";
import { isValidTeamDriverPage } from "./typeguards";
import { TeamDriverPageQuery, TeamDriversVariant } from "../types";
import { CreateTeamDriverPageWidgetInputSchema } from "cdk/graphql";
import { WidgetError, ErrorName } from "../../../utils/errors";
import { intcmpMap } from "../../../utils/intcmp";

export const CARD_TEAM_DRIVERS = 'team-drivers';
export const CARD_DRIVERS = 'drivers';

export default (obj: TeamDriverPageQuery): ITeamsDriversCards => {
  if (isValidTeamDriverPage(obj)) {
    CreateTeamDriverPageWidgetInputSchema().parse( obj.data.getTeamDriverPageWidget,  { reportInput: true });
    const { teamList = [] } = obj.data.getTeamDriverPageWidget;
    
    const filterNulls = <T>(arr: (T | null | undefined)[]): T[] =>
      arr.filter((item): item is T => item != null);

    type TeamList = NonNullable<typeof teamList>;
    type TeamListItem = NonNullable<TeamList[number]>;

    const sortTeamsDrivers = <T extends { position?: number | null }>(teamsDrivers:  T[]): T[] =>
      [...teamsDrivers].sort((driverFirst: T, driverSecond: T) => {
        const driverFirstPosition = driverFirst?.position ?? 99;
        const driverSecondPosition = driverSecond?.position ?? 99;
    
        return driverFirstPosition < driverSecondPosition ? -1 : 1;
      });

    const transformTeamDrivers = (teamDriversArray: TeamList)  => {
      
        const sortedDriversArray = filterNulls(teamDriversArray).map((team: TeamListItem) => ({
          ...team,
          drivers: sortTeamsDrivers(filterNulls(team.drivers || []))
        }));
    
        return sortTeamsDrivers(sortedDriversArray);

    };

    const teamDrivers = transformTeamDrivers(teamList ?? []) ?? [];

    const variant: TeamDriversVariant = CARD_DRIVERS;

    const cards = teamDrivers.map((teamDrivers) => ({
      ...teamDrivers,
      variant,
    }));
    
    return {
      cards: cards as ITeamsDriversCards["cards"],
      trackingData: intcmpMap.teamsDrivers,
      variant,
    };
  } else {
    throw new WidgetError<ErrorName>({
      name: "NO_VALID_DATA",
      message: "Invalid transformer input, Error in TeamDriverPageQuery object",
      data: obj,
    });
  }
};
